module.exports = __webpack_public_path__ + "img/group.98b6a95b.png";